export default __webpack_public_path__ + "media/images/card-becoming-certification-body.jpg";